const KEY = 'oalosas_lead_email'

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export function getStoredEmail(): string {
  try {
    return localStorage.getItem(KEY) ?? ''
  } catch {
    return ''
  }
}

export function storeEmail(email: string): void {
  try {
    localStorage.setItem(KEY, email.trim().toLowerCase())
  } catch {
    /* almacenamiento no disponible: se pedirá de nuevo */
  }
}
